<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";

export default defineComponent({
  name: "ConsolidatedBudgetIndicatorForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        consolidated_budget_id: null,
        year: null,
        accepted_amount: null,
        accepted_percent: null,
        execution_amount: null,
        execution_percent: null,
        second_execution_amount: null,
        second_execution_percent: null,
        third_execution_amount: null,
        third_execution_percent: null,
        fourth_execution_amount: null,
        fourth_execution_percent: null
      },
      rules: {
        year: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        accepted_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        accepted_percent: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        execution_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        execution_percent: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        second_execution_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        second_execution_percent: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        third_execution_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        third_execution_percent: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        fourth_execution_amount: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        fourth_execution_percent: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      }
    }
  },
  methods: {
    getConsolidatedBudgetById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/consolidated-budget-indicators/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            this.form.year = data.year.toString();
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.year = parseInt(this.form.year)
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/consolidated-budget-indicators/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/consolidated-budget-indicators", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.budget_id) {
      this.form.consolidated_budget_id = parseInt(this.$route.params.budget_id);
    }
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getConsolidatedBudgetById()
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="14" :xl="6">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Yilni tanlang" prop="year">
                <el-date-picker
                    v-model="form.year"
                    type="year"
                    style="width: 100%"
                    value-format="YYYY"
                    placeholder="Yilni tanlang"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <fieldset class="form-fieldset">
            <legend>Tasdiqlangan</legend>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Summa (mlrd.so'm)" prop="accepted_amount">
                  <el-input-number style="width: 100%" type="number" v-model="form.accepted_amount"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="YAIMga nisbatan (%)" prop="accepted_percent">
                  <el-input-number style="width: 100%" type="number" v-model="form.accepted_percent"/>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>

          <fieldset class="form-fieldset">
            <legend>1-chorak ijro</legend>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Summa (mlrd.so'm)" prop="execution_amount">
                  <el-input-number style="width: 100%" type="number" v-model="form.execution_amount"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="YAIMga nisbatan (%)" prop="execution_percent">
                  <el-input-number style="width: 100%" type="number" v-model="form.execution_percent"/>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>

          <fieldset class="form-fieldset">
            <legend>2-chorak ijro</legend>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Summa (mlrd.so'm)" prop="second_execution_amount">
                  <el-input-number style="width: 100%" type="number" v-model="form.second_execution_amount"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="YAIMga nisbatan (%)" prop="second_execution_percent">
                  <el-input-number style="width: 100%" type="number" v-model="form.second_execution_percent"/>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>

          <fieldset class="form-fieldset">
            <legend>3-chorak ijro</legend>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Summa (mlrd.so'm)" prop="third_execution_amount">
                  <el-input-number style="width: 100%" type="number" v-model="form.third_execution_amount"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="YAIMga nisbatan (%)" prop="third_execution_percent">
                  <el-input-number style="width: 100%" type="number" v-model="form.third_execution_percent"/>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>

          <fieldset class="form-fieldset">
            <legend>4-chorak ijro</legend>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="Summa (mlrd.so'm)" prop="fourth_execution_amount">
                  <el-input-number style="width: 100%" type="number" v-model="form.fourth_execution_amount"/>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-form-item label="YAIMga nisbatan (%)" prop="fourth_execution_percent">
                  <el-input-number style="width: 100%" type="number" v-model="form.fourth_execution_percent"/>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>


          <el-row>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.form-fieldset {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  margin-bottom: 20px;
}
</style>
